import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Publications from './pages/Publications';
import Teaching from './pages/Teaching';
import Talks from './pages/Talks';
import Software from './pages/Software';
import Colles20232024 from './pages/Colles2023-2024';
import Colles20222023 from './pages/Colles2022-2023';
import Gdds from './pages/Gdds';

// Custom hook to scroll to top on route changes
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-[radial-gradient(circle_at_top,_rgba(120,113,108,0.10),_transparent_28%),linear-gradient(180deg,_#faf8f4,_#f3efe7)] text-slate-800">
        <Navbar />
        <main className="container mx-auto px-4 py-10 animate-fade-in">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/talks" element={<Talks />} />
            <Route path="/software" element={<Software />} />
            <Route path="/gdds" element={<Gdds />} />
            <Route path="/teaching" element={<Teaching />} />
            <Route path="/teaching/2023-2024" element={<Colles20232024 />} />
            <Route path="/teaching/2022-2023" element={<Colles20222023 />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App; 
